module.exports = __webpack_public_path__ + "img/view.c1b1ac88.svg";